const initialState = {
  // Campaign
  campaignItems: [],
  campaignItemsHasErrored: false,
  campaignItemsIsLoading: false,
  campaignItem: null,
  campaignItemHasErrored: false,
  campaignItemIsLoading: false,
  isNewCampaignSaveSuccess: false,
  isNewCampaignSaveErrored: false,
  isNewCampaignIsSaving: false,
  redirectToCampaignListPage: false,

  // Promotion
  promotionList: [],
  promotionListHasErrored: false,
  promotionListIsLoading: false,
  promotionDetails: null,
  promotionDetailsHasErrored: false,
  promotionDetailsIsLoading: false,
  isNewPromotionSaveSuccess: false,
  isNewPromotionSaveErrored: false,
  isNewPromotionIsSaving: false,
  redirectToPromotionListPage: false,

  // Offer
  offerList: [],
  offerListHasErrored: false,
  offerListIsLoading: false,
  offerDetails: null,
  offerRule: null,
  offerDetailsHasErrored: false,
  offerDetailsIsLoading: false,
  isNewOfferSaveSuccess: false,
  isNewOfferSaveErrored: false,
  isNewOfferIsSaving: false,
  redirectToOfferListPage: false,
  activateOfferDataSuccess: false,
  activateOfferSaving: false,
  activateOfferErrored: false,

  // CAF Import
  fileUploadSuccess: false,
  fileUploadErrored: false,
  fileIsUploading: false,
  cafOfferList: [],
  cafOfferListHasErrored: false,
  cafOfferListIsLoading: false,
  cafHistoryListHasErrored: false,
  cafHistoryListIsLoading: false,
  cafHistoryList: [],
  purchaseRebateCafListHasErrored: false,
  purchaseRebateCafListIsLoading: false,
  purchaseRebateCafHistoryList: [],

  // Supplier
  supplierItems: [],
  supplierItemsHasErrored: false,
  supplierItemsIsLoading: false,
  supplierItem: null,
  supplierItemHasErrored: false,
  supplierItemIsLoading: false,
  purchaseRebateSupplierItems: [],
  purchaseRebateSupplierItemsHasErrored: false,
  purchaseRebateSupplierItemsIsLoading: false,
  purchaseRebateSupplierItem: null,
  purchaseRebateSupplierItemHasErrored: false,
  purchaseRebateSupplierItemIsLoading: false,
  isNewPurchaseRebateSupplierSaveSuccess: false,
  isNewPurchaseRebateSupplierSaveErrored: false,
  isNewPurchaseRebateSupplierIsSaving: false,
  isNewPurchaseRebateSupplierRemoveSuccess: false,
  isNewPurchaseRebateSupplierRemoveErrored: false,
  isNewPurchaseRebateSupplierIsRemoving: false,

  // Region
  siteRegionListHasErrored: false,
  siteRegionListIsLoading: false,
  siteRegionList: [],
  regionListHasErrored: false,
  regionListIsLoading: false,
  regionList: [],
  dealFunderListHasErrored: false,
  dealFunderListIsLoading: false,
  dealFunderList: [],
  updateSiteRegionHasErrored: false,
  siteRegionUpdating: false,
  siteRegionUpdateSuccess: false,
  addSiteRegionHasErrored: false,
  siteRegionAdding: false,
  siteRegionAddSuccess: false,

  // Rule Product
  ruleProductListHasErrored: false,
  ruleProductListIsLoading: false,
  ruleProductListFetchDataSuccess: [],
  newRuleProductSaveErrored: false,
  nnewRuleProductIsSaving: false,
  newRuleProductSaveSuccess: false,
  deleteRuleProductHasErrored: false,
  deleteRuleProductIsLoading: false,
  deleteRuleProductSuccess: false,

  // Batch Process
  batchProcessListHasErrored: false,
  batchProcessListIsRunning: false,
  batchProcessListSuccess: [],
  runBatchProcessHasErrored: false,
  runBatchProcessIsRunning: false,
  runBatchProcessSuccess: false,
  rollbackBatchProcessHasErrored: false,
  rollbackBatchProcessIsRunning: false,
  rollbackBatchProcessSuccess: false,

  // Deal Funder
  dealFunder: [],

  // Loss Prevention
  lossPreventionSettings: {},

  // Purchase Rebate
  purchaseRebateItemsHasErrored: false,
  purchaseRebateItemsIsLoading: false,
  purchaseRebateItems: [],
  purchaseRebateItemHasErrored: false,
  purchaseRebateItemIsLoading: false,
  purchaseRebateItem: null,
  purchaseRebateProductItemsHasErrored: false,
  purchaseRebateProductItemsIsLoading: false,
  purchaseRebateProductItems: [],

  // Conversion Rate
  conversionRateListHasErrored: false,
  conversionRateListIsLoading: false,
  conversionRateListData: [],
  conversionRateAddHasErrored: false,
  conversionRateAddIsLoading: false,
  isConversionRateAddSuccess: false,
  conversionRateAddDataSuccess: false,
  eftCategoriesListHasErrored: false,
  eftCategoriesListIsLoading: false,
  eftCategoriesListData: [],
  conversionRateDeleteHasErrored: false,
  conversionRateDeleteIsLoading: false,
  conversionRateDeleteDataSuccess: false,
  conversionRateSetEndDateHasErrored: false,
  conversionRateSetEndDateIsLoading: false,
  conversionRateSetEndDateDataSuccess: false,
};

export default initialState;
